"use client";

import { useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";

interface TabsDemoProps {
  className?: string;
  trigger: string[];
  content: React.ReactNode[];
  stableKeys?: string[];
  disabled?: boolean;
  activeTabOnDisabled?: string;
}

const TabsDemo = ({ ...props }: TabsDemoProps) => {
  // Use stable keys if provided, otherwise fall back to trigger values
  const keys = props.stableKeys || props.trigger;
  const [activeTab, setActiveTab] = useState(keys[0] || "");

  return (
    <>
      <Tabs
        className={`flex w-full flex-col gap-6 ${props.className}`}
        value={props.disabled ? props.activeTabOnDisabled : activeTab}
        onValueChange={setActiveTab}
      >
        {/* Desktop Tabs List for larger screens */}
        <TabsList className="s:block hidden">
          {props.trigger?.map((item, index) => (
            <TabsTrigger
              key={keys[index]}
              value={keys[index]}
              disabled={props.disabled}
            >
              {item}
            </TabsTrigger>
          ))}
        </TabsList>

        {/* Mobile Select for smaller screens */}
        <Select
          disabled={props.disabled}
          value={activeTab}
          onValueChange={setActiveTab}
        >
          <SelectTrigger className="s:hidden flex w-full" size="sm">
            <SelectValue placeholder={props.trigger[0]} />
          </SelectTrigger>
          <SelectContent>
            {props.trigger?.map((item, index) => (
              <SelectItem key={keys[index]} value={keys[index]}>
                {item}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        {props.content?.map((item, index) => {
          return (
            <TabsContent key={keys[index]} value={keys[index]}>
              {item}
            </TabsContent>
          );
        })}
      </Tabs>
    </>
  );
};

export default TabsDemo;
